module.exports = __webpack_public_path__ + "img/5.bdb67c4c.png";